import React, { Component } from 'react'
import moment from 'moment-timezone'
import ProfilePicture from 'components/profile/profile-picture'
import { connect } from 'react-redux'

import { forIn, forEachRight } from 'lodash'
import copy from 'fast-copy'
import isEqual from 'react-fast-compare'

import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'

import {
	likeComment,
	likeMessage,
	handleTouchMove,
	openModal,
	getMissingEntities
} from 'state/actions'

import { withRouter } from 'react-router'

import MessageGroup from './message-group'
import CommmentReplyNotice from './comment-reply-notice'

import Scroll from 'react-scroll'

import {
	formatByTimeZone,
	isMobile,
	getFileDisplayData,
	getOnlineDotProps,
	ucfirst
} from 'utils'

import queryString from 'query-string'

import { createSelector } from 'reselect'

class MessageList extends Component {
	state = {
		currentlyEditedComment: null,
		hasMountedWithDelay: false, // small allowance for initial scroll, so...
	}

	contentRefs = []
	lastCalculatedScrollHeight = 0
	scroll = Scroll.animateScroll
	oldScroll = null // to detect scroll direction
	requestedmissingChatItemIds = []
	el = null
	element = null // may be doubled up here
	renderedUserIds = [] // so isGroup is true, even if they've left

	scrollToBottom = noAnimate => {
		const {
			hasMountedWithDelay
		} = this.state

		const {
			optimistic,
			messageObject,
			isFetching
		} = this.props

		// this absolute madness is my vain attempt to keep the bloody message list scrolled to the bottom...
		if (optimistic || !hasMountedWithDelay) {
			return
		}

		window.requestAnimationFrame(_ => {
			if (isFetching) {
				return
			}

			setTimeout(_ => {
				if (!noAnimate) {
					this.scroll.scrollToBottom({
						duration: 100,
						delay: 1,
						containerId: 'message-list-' + messageObject.id,
					})
				} else {
					if (this.el) {
						this.el.scrollTop = 999999
					}
				}
			}, 10)
		})
	}

	shouldComponentUpdate = (nextProps, nextState) => {
		const isStateEqual = isEqual(this.state, nextState)
		const isMessageDataEqual = isEqual(this.props.groupedMessageData, nextProps.groupedMessageData)
		const isRepliedEntityEqual = isEqual(this.props.repliedEntity, nextProps.repliedEntity)
		const isInputsHeightEqual = this.props.inputsHeight === nextProps.inputsHeight
		const isOpenStatusEqual = this.props.isOpen === nextProps.isOpen
		const isKeyboardHeightEqual = this.props.keyboardHeight === nextProps.keyboardHeight
		const isFetchingStatusEqual = this.props.isFetching === nextProps.isFetching
		const isLoadingEqual = this.props.isLoading === nextProps.isLoading // For comments only

		if (!isOpenStatusEqual) {
			setTimeout(_ => {
				this.scrollToBottom(true)
			}, 1)
			return false
		}

		if (isStateEqual && isMessageDataEqual && isInputsHeightEqual && isRepliedEntityEqual && isOpenStatusEqual && isKeyboardHeightEqual && isFetchingStatusEqual && isLoadingEqual) {
			return false
		}

		return true
	}

	componentDidMount = _ => {
		const {
			chatId,
		} = this.props

		window.addEventListener("resize", this.recalcHeightOnMobile)

		// We're really aggressively forcing scroll-to-bottom here, jumps around otherwise.
		const forceScrollInterval = setInterval(_ => {
			if (this.state.hasMountedWithDelay) {
				return clearInterval(forceScrollInterval)
			}

			if (this.el) {
				this.el.scrollTop = this.el.scrollHeight + 10000
			}
		}, 1)

		// used for comment scrolls and mobile event listeners
		this.element = document.getElementById("message-list-" + chatId)

		setTimeout(_ => {
			this.setState({
				hasMountedWithDelay: true
			})
		}, 1400)

		setTimeout(_ => {
			if (this.el) {
				this.el.classList.add('mounted')
			}
		}, 400)

		if (isMobile() && chatId) {
			this.element.addEventListener('touchmove', e => {
				handleTouchMove(e, 'move')
			}, { passive: false })

			this.element.addEventListener('touchstart', e => {
				handleTouchMove(e, 'start')
			}, { passive: false })

			disableBodyScroll(this.element)
		}
	}

	componentWillUnmount() {
		if (isMobile()) {
			if (this.element) {
				this.element.removeEventListener('touchmove', e => {
					handleTouchMove(e, 'move')
				})

				this.element.removeEventListener('touchstart', e => {
					handleTouchMove(e, 'start')
				})
			}

			window.removeEventListener("resize", this.recalcHeightOnMobile)

			clearAllBodyScrollLocks()
		}
	}

	recalcHeightOnMobile = _ => {
		if (isMobile()) {
			this.scrollToBottom(true)
		}
	}

	blockFetchMore = false

	UNSAFE_componentWillUpdate = nextProps => {
		const {
			isFetching,
			messageObject,
			hasMounted
		} = this.props

		const shouldCacheScrollHeight = !isFetching // || (isFetching && !nextProps.isFetching)

		if (shouldCacheScrollHeight) {
			this.lastCalculatedScrollHeight = this.el.scrollHeight
		}

		if (messageObject.id !== nextProps.messageObject.id) {
			this.versionsRendered = []
		}

		if (isFetching && !nextProps.isFetching) {
			let newScrollTop = this.el.scrollTop
			let newHeight = this.el.scrollHeight
			let oldHeight = this.lastCalculatedScrollHeight

			const heightDelta = newHeight - oldHeight
			const extraScrollAllowance = 30 // it's mathematically correct but always off. I blame the browser.

			const heightToScrollTo = newScrollTop + heightDelta - extraScrollAllowance

			this.el.scrollTop = heightToScrollTo

			/*
				I'm struggling to put into words how much I loathe iOS.
				This is only here because it scrolls to wherever it feels like, for no reason at all.
			*/
			if (isMobile()) {
				let forceScrollIterator = 0

				const forceScrollInterval = setInterval(_ => {
					if (this.el) {
						this.el.scrollTop = heightToScrollTo
					}

					forceScrollIterator += 1

					if (forceScrollIterator > 80) {
						clearInterval(forceScrollInterval)
					}
				}, 5)
			}
		}
	}

	getDistanceFromBottom = _ => {
		if (this.element) {
			return this.element.scrollHeight - (this.element.scrollTop + this.element.clientHeight)
		} else {
			return 0
		}
	}

	componentDidUpdate = prevProps => {
		const {
			keyboardHeight,
			isFetching,
			inputsHeight,
			isOpen,
			repliedEntity,
			groupedMessageData,
			messageObject,
			getMissingEntities,
			isLoading,
			location
		} = this.props

		const {
			missingChatItemIds
		} = groupedMessageData

		const chatItemIdsToRequest = []

		missingChatItemIds.forEach(missingChatItemId => {
			if (!this.requestedmissingChatItemIds.includes(missingChatItemId)) {
				chatItemIdsToRequest.push(missingChatItemId)
				this.requestedmissingChatItemIds.push(missingChatItemId)
			}
		})

		if (chatItemIdsToRequest.length) {
			getMissingEntities({
				chatItems: chatItemIdsToRequest
			})
		}

		if (isFetching || prevProps.isFetching) {
			return
		}

		if (keyboardHeight != prevProps.keyboardHeight || inputsHeight != prevProps.inputsHeight) {
			this.recalcHeightOnMobile()
		}

		const distanceFromBottom = this.getDistanceFromBottom()

		if (prevProps.groupedMessageData.typingUser && !groupedMessageData.typingUser) {
			return this.resetScrollBecauseChromeIsBeingStupid()
		}

		if (groupedMessageData.typingUser && groupedMessageData.typingUser !== prevProps.groupedMessageData.typingUser && distanceFromBottom < 250) {
			return this.scrollToBottom(false, 'typing user')
		}

		if (isOpen && !prevProps.isOpen) {
			return this.scrollToBottom(true, 'isnowopen')
		}

		if (!prevProps.repliedEntity && repliedEntity) {
			setTimeout(_ => {
				this.scroll.scrollMore(110, {
					duration: 200,
					smooth: "easeInOutQuint",
					containerId: 'message-list-' + messageObject.id,
				})
			}, 5)
		}

		if (prevProps.activeSearchResult !== this.props.activeSearchResult && this.props.activeSearchResult !== null && window.activeMessage) {
			const activeMessageBounding = window.activeMessage.getBoundingClientRect()
			const screenMiddle = window.innerHeight / 2

			const delta = screenMiddle - activeMessageBounding.top - (activeMessageBounding.height / 2)

			this.scroll.scrollMore(-delta, {
				duration: 200,
				smooth: "easeInOutQuint",
				containerId: 'message-list-' + messageObject.id,
			})

			window.activeMessage = null
		}

		if (!isLoading && prevProps.isLoading) {
			setTimeout(_ => {
				const thisQueryString = location.search
				const queries = queryString.parse(thisQueryString)

				if (queries.comment) {
					const commentId = parseInt(queries.comment)

					const commentElement = document.getElementById('message-group-' + commentId)
					const messageListElement = document.getElementById('message-list-' + messageObject.id)

					if (commentElement && messageListElement) {

						const messageListBounding = messageListElement.getBoundingClientRect()

						const middleOfMessageBox = messageListBounding.top + (messageListBounding.height / 2)
						const topOfComment = commentElement.getBoundingClientRect().top

						const difference = topOfComment - middleOfMessageBox

						this.scroll.scrollMore(difference, {
							duration: 200,
							smooth: "easeInOutQuint",
							containerId: 'message-list-' + messageObject.id,
						})
					}
				}
			}, 500)
		}
	}

	resetScrollBecauseChromeIsBeingStupid = _ => {
		// EUGHHHHHHHHHHHHHHHHHHH
		// If you remove this, subsequent changes to typingUser won't animate...

		if (this.el) {
			this.el.scrollTop = this.el.scrollTop - 1
		}
	}

	handleScroll = e => {
		// This just requests more messsages if you've scrolled up.
		let scrollTop = this.el.scrollTop

		const {
			messageObject,
			hasFetchedAll,
			isFetching,
			fetchRequest
		} = this.props

		const {
			hasMountedWithDelay
		} = this.state

		if (scrollTop < 30) {
			if (isFetching) {
				this.el.scrollTop = 30
			} else {
				if (messageObject && messageObject.chat_items && !hasFetchedAll && !this.blockFetchMore && hasMountedWithDelay) {
					this.blockFetchMore = true

					fetchRequest(messageObject.chat_items.length, _ => {
						setTimeout(_ => {
							this.blockFetchMore = false
						}, 500)
					})
				}
			}
		}

		this.oldScroll = scrollTop
	}

	likeEntity = (entity, type) => {
		this.props[`like${ucfirst(type)}`](entity, this.props.thisUser)
	}

	editComment = message => {
		this.setState({
			currentlyEditedComment: copy(message),
		}, _ => {
			this.contentRefs[message.id].htmlEl.focus()
		})
	}

	handleEditCommentChange = e => {
		this.setState({
			currentlyEditedComment: {
				...this.state.currentlyEditedComment,
				text: e.target.value
			}
		})
	}

	deleteComment = message => {
		this.props.deleteCallback(message)
	}

	saveEditedComment = _ => {
		this.props.updateCallback(this.state.currentlyEditedComment)

		this.setState({
			currentlyEditedComment: null
		})
	}

	cancelEditComment = _ => {
		this.setState({
			currentlyEditedComment: null,
		})
	}

	processUploadData = messageGroup => {
		let versions = messageGroup.messages

		let newFiles = []
		let updatedFiles = []

		let fileDisplayData
		let description

		if (versions.length == 1) {
			let firstVersion = versions[0].version

			fileDisplayData = getFileDisplayData(firstVersion.filename)

			if (versions[0].isNewVersion) {
				description = "Uploaded " + fileDisplayData.article + " " + fileDisplayData.taxonomy + ":"

				newFiles.push(versions[0])
			} else {
				description = "Uploaded a new version of \"" + versions[0].file.name + '"'

				updatedFiles.push(versions[0])
			}
		} else if (versions.length > 1) {
			versions.forEach(version => {
				if (version.isNewVersion) {
					newFiles.push(version)
				} else {
					updatedFiles.push(version)
				}
			})

			if (newFiles.length && updatedFiles.length) {
				description = `Uploaded ${newFiles.length} new file${newFiles.length > 1 ? 's' : ''}, and updated ${updatedFiles.length}:`
			} else if (newFiles.length) {
				description = `Uploaded ${newFiles.length} new file${newFiles.length > 1 ? 's' : ''}:`
			} else if (updatedFiles.length) {
				description = `Uploaded ${updatedFiles.length > 1 ? 'new versions' : 'a new version'} of ${updatedFiles.length} file${updatedFiles.length > 1 ? 's' : ''}:`
			}
		}

		newFiles.sort((a, b) => {
			return a - b
		})

		updatedFiles.sort((a, b) => {
			return a - b
		})

		return {
			description,
			newFiles,
			updatedFiles
		}
	}

	getUserName = user => {
		const {
			messageObject,
			allUsers
		} = this.props

		const userIds = messageObject.userIds ? messageObject.userIds : messageObject.users

		const usersWithThisFirstName = userIds.filter(userId => {
			const tempUser = allUsers[userId]

			return tempUser?.first_name == user.first_name
		})

		return (
			<span className="user-name">
				{usersWithThisFirstName.length > 1 ? `${user.first_name} ${user.last_name}` : `${user.first_name || 'Deleted user'}`}
			</span>
		)
	}

	openPreviewModal = version => {
		// this is actually stale, as it won't recalculate when an image is finished processing.
		let versions = []

		this.versionsRendered.forEach(versionRendered => {
			const tempVersion = this.props.allVersions[versionRendered.id]
			const tempFile = this.props.allFiles[tempVersion.file_id]

			if (!tempFile || tempFile.deleted_at) {
				return
			}

			versions.push(tempVersion)
		})

		const startIndex = versions.findIndex(loopedVersion => {
			return loopedVersion.id === version.id
		})

		this.props.openModal('preview', 'files', {
			versions,
			startIndex
		})
	}

	versionsRendered = []
	versionsRenderedIndex = -1
	smallestScreenSize = 0

	incrementVersionsRenderedData = version => {
		const versionExists = this.versionsRendered.find(loopedVersion => {
			return loopedVersion.id === version.id
		})

		if (!versionExists) {
			this.versionsRendered.push(version)
		}
	}

	getListId = _ => {
		const {
			optimistic,
			messageObject,
			chatId
		} = this.props

		return optimistic ? 'message-list-optimistic' : 'message-list-' + (chatId ? chatId : messageObject.id)
	}

	handleMessageItemMountOrLoad = (userId, isLast) => {
		if (this.renderedUserIds.indexOf(userId) === -1) {
			this.renderedUserIds.push(userId)
		}

		if (!isLast) {
			return
		}

		const {
			hasMountedWithDelay
		} = this.state

		const distanceFromBottom = this.getDistanceFromBottom()

		if (distanceFromBottom < 1000) {
			this.scrollToBottom(!hasMountedWithDelay) // as in, only animate if we've mounted with delay
		}
	}

	render() {
		const {
			messageObject,
			inputsHeight,
			type,
			hasMounted,
			thisUser,
			allUsers,
			onlineUsers,
			groupedMessageData,
			repliedEntity,
			cancelReplyEntity,
			replyEntity,
			prepend
		} = this.props

		const {
			groupedMessages,
			typingUser,
			activeSearchResultObject
		} = groupedMessageData

		const {
			currentlyEditedComment,
		} = this.state

		const listId = this.getListId()

		const isGroup = this.renderedUserIds.length > 2 || (messageObject.userIds && messageObject.userIds.length > 2) || messageObject.team_id || messageObject.name

		const typingUserDotProps = (isGroup && typingUser) ? getOnlineDotProps(typingUser, onlineUsers.find(onlineUser => onlineUser.id === typingUser.id)) : null

		let className = 'messages-list'

		if (!groupedMessages.length) {
			className += ' empty'
		}

		if (repliedEntity) {
			className += ' has-reply'
		}

		return (
			<div
				className={className}
				onScroll={this.handleScroll}
				style={(inputsHeight && (isMobile() || hasMounted)) ? {
					height: `calc(100% - ${inputsHeight}px)`
				} : null}
			>
				<ul
					id={listId}
					ref={el => this.el = el}
				>
					{prepend && prepend}
					{groupedMessages.map((messageGroup, i) => {
						if (messageGroup.type == 'message-group') {
							return (
								<MessageGroup
									allUsers={allUsers}
									onlineUsers={onlineUsers}
									cancelEditComment={this.cancelEditComment}
									contentRefs={this.contentRefs}
									currentlyEditedComment={currentlyEditedComment}
									deleteComment={this.deleteComment}
									editComment={this.editComment}
									getUserName={this.getUserName}
									handleEditCommentChange={this.handleEditCommentChange}
									incrementVersionsRenderedData={this.incrementVersionsRenderedData}
									isArchived={(messageObject && messageObject.deleted_at)}
									isGroup={isGroup}
									key={i}
									likeEntity={this.likeEntity}
									messageGroup={messageGroup}
									openPreviewModal={this.openPreviewModal}
									processUploadData={this.processUploadData}
									saveEditedComment={this.saveEditedComment}
									thisUser={thisUser}
									type={type}
									versionsRenderedIndex={this.versionsRenderedIndex}
									versionsRendered={this.versionsRendered}
									replyEntity={replyEntity}
									handleMessageItemMountOrLoad={userId => this.handleMessageItemMountOrLoad(userId, (i + 1) === groupedMessages.length)}
									activeSearchResultObject={activeSearchResultObject}
								/>
							)
						} else if (messageGroup.type == 'day-divider') {
							return (
								<li className="clear day-divider" key={i}>
									<span>
										{(() => {
											const dateMoment = formatByTimeZone(messageGroup.date, null, true)
											const isCurrentYear = dateMoment.year() === new Date().getFullYear()
											return dateMoment.format(isCurrentYear ? 'Do MMMM' : 'Do MMMM YYYY')
										})()}
									</span>
								</li>
							)
						}
					})}
					{
						typingUser ?
							<li className="typing-user">
								{typingUserDotProps && <em {...typingUserDotProps} />}
								<ProfilePicture user={typingUser} isTiny={true} />
								<div className="message-content">
									<i />
									<i />
									<i />
								</div>
							</li>
							: null
					}
				</ul>
				<CommmentReplyNotice
					allUsers={allUsers}
					thisUser={thisUser}
					comment={repliedEntity}
					cancelReplyEntity={cancelReplyEntity}
				/>
			</div>
		);
	}
}

const getGroupedMessages = createSelector(
	[
		(state, props) => props.messageObject,
		(state, props) => props.type,
		state => state.account.entities.users[state.auth.userId],
		state => state.account.entities,
		(state, props) => props.pendingComments,
		(state, props) => props.pendingMessages,
		(state, props) => props.optimistic,
		(state, props) => props.typingUserData,
		(state, props) => props.activeSearchResult,
	],
	(messageObject, type, user, entities, pendingComments, pendingMessages, optimistic, typingUserData, activeSearchResult) => {
		let messages = []

		if (optimistic) {
			return messages
		}

		const allChatResultResults = entities.chat_search_results

		const {
			comments,
			chat_items,
			users,
			versions = {},
			files
		} = entities

		let messageObjectKey
		let allCommentsOrItems
		let pendingArray
		let textKey
		let senderKey

		const missingChatItemIds = []

		let typingUser = null

		if (typingUserData && type == 'message') {
			forIn(typingUserData, (data, userId) => {
				if (!typingUser && data.chatId == messageObject.id && parseInt(userId) !== user.id && data.isTyping) {
					typingUser = users[userId]
				}
			})
		}

		if (type == 'comment') {
			messageObjectKey = 'comments'
			allCommentsOrItems = comments
			pendingArray = pendingComments
			textKey = 'text'
			senderKey = 'user_id'
		} else {
			messageObjectKey = 'chat_items'
			allCommentsOrItems = chat_items
			pendingArray = pendingMessages
			textKey = 'message_text'
			senderKey = 'sender_id'
		}

		const activeSearchResultObject = (() => {
			if (!allChatResultResults || !messageObject.search_results) {
				return null
			}

			const activeSearchResultId = messageObject.search_results[activeSearchResult]

			return allChatResultResults[activeSearchResultId]
		})()

		let allItems = null

		if (activeSearchResultObject) {
			allItems = activeSearchResultObject.chat_items
		} else {
			allItems = messageObject[messageObjectKey]
		}

		// create array of message objects
		forIn(allItems, itemId => {
			const chatItem = allCommentsOrItems[itemId]

			// we actually do want to show deleted comments - means the task's archived.
			if (!chatItem || (chatItem.deleted_at && !chatItem.text)) {
				return
			}

			let object

			if (type == 'comment') {
				messages.push(chatItem)
				return
			} else {
				// It should NEVER get here. I cannot work out why it does.
				if (chatItem.chat_id !== messageObject.id) {
					return
				}
			}

			switch (chatItem.item_type) {
				case 'App\\Message':
					if (!chatItem.object) {
						return
					}
					object = entities.messages[chatItem.object.id] ? {
						...entities.messages[chatItem.object.id]
					} : null

					const isSearchResult = activeSearchResultObject && activeSearchResultObject.resultId === chatItem.id

					if (object) {
						if (object.replying_to) {
							const replyMessage = entities.messages[object.replying_to]

							if (replyMessage) {
								object.replyingTo = {
									...replyMessage,
									user: entities.users[replyMessage.sender_id]
								}
							}
						}

						if (isSearchResult) {
							messages.push({
								...object,
								isSearchResult: true,
							})
						} else {
							messages.push(object)
						}
					}
					break
				case 'App\\Version':
					if (!chatItem.object) {
						return
					}

					object = versions[chatItem.object.id]

					if (!object) {
						missingChatItemIds.push(chatItem.id)
						return
					}

					const file = files[object.file_id]

					if (!file || file.deleted_at) {
						return
					}

					// sort versions by ID, so we can reliably tell if it's a new one.
					let versionIndex = 0

					if (file.versions) {
						file.versions.sort((a, b) => {
							return a - b
						})

						versionIndex = file.versions ? file.versions.indexOf(object.id) : 0
					}

					if (!file.latestVersion) {
						return null
					}

					let versionMessageObject = {
						version: object,
						file,
						isNewVersion: !versionIndex,
						isLatestVersion: object.id == file.latestVersion.id
					}

					messages.push({
						created_at: object.created_at,
						type: 'upload',
						...versionMessageObject
					})

					break
			}
		})

		// add in pending messages (for optimistic UI)
		pendingArray.forEach(message => {
			messages.push({
				[textKey]: message,
				[senderKey]: user.id,
				created_at: moment().tz('Australia/Melbourne').format('YYYY-MM-DD HH:mm:ss')
			})
		})

		// append all the 'versions' (uploads) to the messages list. gets sorted afterwards
		type == 'comment' && forIn(messageObject.versions, versionId => {
			let version = versions[versionId]

			if (!version) {
				return
			}

			let file = files[version.file_id]

			if (!file || file.deleted_at) {
				return
			}

			// sort versions by ID, so we can reliably tell if it's a new one.
			let versionIndex = 0

			if (file.versions) {
				file.versions.sort((a, b) => {
					return a - b
				})

				versionIndex = file.versions ? file.versions.indexOf(version.id) : 0
			}

			let isNewVersion = true

			if (versionIndex > 0) {
				isNewVersion = false
			}

			// it should really never not have latestVersion, but it always finds a way, doesn't it?
			const versionMessageObject = {
				version,
				file,
				isNewVersion,
				isLatestVersion: !file.latestVersion || version.id === file.latestVersion.id
			}

			messages.push({
				created_at: version.created_at,
				type: 'upload',
				...versionMessageObject
			})
		})

		messages.sort((a, b) => {
			return a.created_at.localeCompare(b.created_at)
		})

		const replies = []

		forEachRight(messages, (message, index) => {
			if (message.comment_reply_id) {
				replies.push(message)

				messages.splice(index, 1)
			}
		})

		replies.forEach(reply => {
			const repliedMessageIndex = messages.findIndex(message => {
				return message.id === reply.comment_reply_id
			})

			if (repliedMessageIndex !== -1) {
				messages.splice(repliedMessageIndex + 1, 0, reply)
			}
		})

		let groupedMessages = []

		let lastLoopedUserId = 0
		let isLastLoopedFile = false
		let isLastLoopedReply = false
		let lastLoopedMessageDay = ''

		// Group messages by user/date
		messages.forEach(message => {
			let messageUserId = null
			let isUpload = false

			if (message.type == 'upload') {
				isUpload = true
				messageUserId = message.version.user_id
			} else if (type == 'comment') {
				messageUserId = message.user_id
			} else {
				messageUserId = message.sender_id
			}

			// Add dividers between days
			let isDifferentDay = false
			const messageDay = formatByTimeZone(message.created_at, 'D')
			const repliedCommentId = message.comment_reply_id

			const hasReplyStatusChanged = (repliedCommentId && !isLastLoopedReply) || (!repliedCommentId && isLastLoopedReply)

			if (messageDay != lastLoopedMessageDay) {
				isDifferentDay = true
			} else if (!repliedCommentId && isLastLoopedReply) {
				// gone from a reply to a non-reply
				const repliedComment = allCommentsOrItems[isLastLoopedReply]

				let tempMessageDay = formatByTimeZone(repliedComment.created_at, 'D')

				if (tempMessageDay != lastLoopedMessageDay) {
					isDifferentDay = true
				}
			}

			lastLoopedMessageDay = messageDay

			if (isDifferentDay && !repliedCommentId) {
				groupedMessages.push({
					type: 'day-divider',
					date: message.created_at
				})
			}

			// if different user, different type, or different day, create a new group.
			if (lastLoopedUserId != messageUserId || hasReplyStatusChanged || (isLastLoopedFile != isUpload) || isDifferentDay) {
				// add a new 'group'
				const tempMessageGroup = {
					type: 'message-group',
					isUpload,
					isReply: !!repliedCommentId,
					startDateTime: message.created_at,
					messages: [
						message
					]
				}

				if (isUpload && message.version) {
					tempMessageGroup.user = entities.users[message.version.user_id]
				} else if (type == 'comment') {
					if (message.user_id) {
						tempMessageGroup.user = entities.users[message.user_id]
					}
				} else {
					tempMessageGroup.user = entities.users[message.sender_id]
				}

				// Replies go and find their parent - they'll always come later in the loop. 
				groupedMessages.push(tempMessageGroup)

				lastLoopedUserId = messageUserId

				if (isUpload) {
					isLastLoopedFile = true
				} else {
					isLastLoopedFile = false
				}
			} else {
				// add this message to the last group
				let lastMessageGroup = groupedMessages[(groupedMessages.length - 1)]

				lastMessageGroup.messages.push(message)

				isLastLoopedFile = isUpload
			}

			isLastLoopedReply = repliedCommentId
		})

		return {
			groupedMessages,
			typingUser,
			totalItems: messages.length,
			missingChatItemIds,
			activeSearchResultObject
		}
	}
)

const mapStateToProps = (state, ownProps) => {
	return {
		allUsers: state.account.entities.users,
		thisUser: state.account.entities.users[state.auth.userId],
		onlineUsers: state.account.onlineUsers,
		groupedMessageData: getGroupedMessages(state, ownProps),
		allVersions: state.account.entities.versions,
		allFiles: state.account.entities.files,
		allChatResultResults: state.account.entities.chat_search_results,
	}
}

export default withRouter(connect(mapStateToProps, {
	likeComment,
	likeMessage,
	openModal,
	getMissingEntities
})(MessageList))
